import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header_ouvid';
import Head from '../../components/head';
import Footer from '../../components/footer';
import FormOuvid from '../../components/ouvidoria/form_cad';

function OuvidoriaScreen() {
    return (
        <Fragment>
            <Head titulo="Cadastro de Requisição - Ouvidoria Municipal" />
            <Header />
            <Container>
               <FormOuvid /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OuvidoriaScreen;